import React, { useState, ChangeEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Grid, Box, Typography } from '@mui/material';
import {
  ImageContainer,
  FormContainer,
  StyledButton,
  StyledTextField,
  GridContainer,
} from '../ChangePassword/ChangePassword.styles';
import BackGround from '../../../../Assets/AuthBackGround/AuthBG.png';
import { useParams } from 'react-router-dom';
import { resetPassword } from '../signApi';
import { useSnackbar } from '../../../../Context/SnackbarContext';
import { checkUseridExists } from '../../Admin/User/userApi';

interface ForgetPasswordProps { }

interface FormValues {
  userId: string;
}

const ForgetPassword: React.FC<ForgetPasswordProps> = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { userId } = location.state || { userId: '' };
  const { tenant } = useParams<{ tenant: string }>();
  const [formValues, setFormValues] = useState<FormValues>({
    userId: userId || '',
  });
  const { showSnackbar } = useSnackbar();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isWaiting, setIsWaiting] = useState<boolean>(false);


  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setErrorMessage('');
  };

  const handleUserIdBlur = async () => {
        const userId = formValues.userId.trim();
    
        if (userId === "") {
          setErrorMessage('User ID is required.');
          return false;
        }
    
        try {
          const result = await checkUseridExists(tenant, { UserID: userId ,CheckFor:"login"});
    
          if (!result) {
            setErrorMessage('User ID not found. Please enter a valid one.');
            return false;
          } else {
            setErrorMessage('')
            return true;
          }
        } catch (error) {
          console.error("User ID check failed:", error);
          setErrorMessage('Error validating User ID. Please try again later.')
          return false;
        }
      };

  const handleSubmit = async () => {
    if (!formValues.userId.trim()) {
      setErrorMessage('UserId Is required.')
      return
    }
    const validUserId = await handleUserIdBlur()

    if(!validUserId){
      return
    }
    const userId = formValues.userId;

    try {
      const payLoad = {
        "UserID": userId
      }
      setIsWaiting(true);
      const response = await resetPassword(tenant, payLoad)

      if (response) {
        if(response.Status){
          showSnackbar("A link to reset your password has been sent to your email.", "success")
        // Navigate to Sign In with snackbar message
        navigate(`/${tenant}/SignIn`);
        }
        else{
          setErrorMessage(response.Message || "Your account is inactive. Please contact the administrator for assistance." )
        }
      } 
    } catch (error) {
      showSnackbar("Failed to send reset email.Please try again.", "error")
      console.log(error)
    } finally {
      setIsWaiting(false);
    }
  };


  // Handle key press event for Enter key
  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <Grid container sx={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
      {/* Left side with image */}
      <Grid item xs={12} md={6} sx={{ width: '50%', height: '100vh' }}>
        <ImageContainer
          sx={{
            backgroundImage: `url(${BackGround})`,
            height: '100vh',
            width: '100%',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      </Grid>

      {/* Right side with form */}
      <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <FormContainer sx={{ width: '32vw', padding: '2rem' }}>
          <Box sx={{ width: '100%', marginBottom: '20px' }}>
            <Typography variant="h4" sx={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px' }}>
              Forgot Password
            </Typography>
            <Typography variant="subtitle1" sx={{ fontSize: '18px' }}>
              We will send an email to reset your password.
            </Typography>
          </Box>

          <Box sx={{ width: '100%' }}>
            <GridContainer container spacing={2}>
              <Grid item xs={12}>
                <StyledTextField
                  type="text"
                  label="User ID"
                  name="userId"
                  value={formValues.userId}
                  onChange={handleChange}
                  onBlur={handleUserIdBlur}
                  required
                  size="small"
                  sx={{ width: '30vw' }}
                  error={!!errorMessage}
                  helperText={errorMessage}
                  autoComplete='off'
                  onKeyDown={handleKeyPress}
                />
              </Grid>
            </GridContainer>

            <GridContainer container spacing={3} sx={{ alignItems: 'center' }}>
              <Grid item xs={12}>
                <StyledButton
                  onClick={handleSubmit}
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ width: '30vw' }}
                  disabled={isWaiting}
                >
                  Send Reset Email
                </StyledButton>
              </Grid>
            </GridContainer>
          </Box>
        </FormContainer>
      </Grid>
    </Grid>
  );
};

export default ForgetPassword;
